enum UploadTableDisplayModeTypes {
  ALL = "ALL",
  DUPLICATES = "DUPLICATES",
  PENDING = "PENDING",
  UPLOADED = "UPLOADED",
  FAILED = "FAILED"
}

export default UploadTableDisplayModeTypes